import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navLinks = [
    { name: '關於我們', path: '/' },
    { name: '東川町海外見學', path: '/higashikawa', highlight: true },
    { name: '藝術x再生', path: '/' },
    { name: '影響力學習', path: '/' },
    { name: '青年公寓', path: '/' },
  ];

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/90 backdrop-blur-sm py-4'}`}>
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
            B
          </div>
          <span className="text-xl font-bold text-gray-900 tracking-wider">相信世代</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link 
              key={link.name} 
              to={link.path}
              className={`text-sm font-medium transition-colors ${link.highlight ? 'text-teal-600 font-bold' : 'text-gray-600 hover:text-teal-600'}`}
            >
              {link.name}
            </Link>
          ))}
          <button className="btn-primary py-2 px-5 text-sm">我要支持</button>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-gray-600 text-2xl" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <SafeIcon name={mobileMenuOpen ? "X" : "Menu"} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg border-t py-4 px-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link 
              key={link.name} 
              to={link.path}
              className={`text-base font-medium p-2 rounded-md ${link.highlight ? 'text-teal-600 bg-teal-50' : 'text-gray-800'}`}
            >
              {link.name}
            </Link>
          ))}
          <button className="btn-primary w-full mt-2">我要支持</button>
        </div>
      )}
    </header>
  );
};

export default Navbar;